/* eslint-disable react/no-unknown-property */
import React from "react";
import WarningIcon from "@mui/icons-material/Warning";
import SeenCheckbox from "../seen_checkbox";
import PropTypes from "prop-types";
import styled from "styled-components";

export const TODOListModalBaseConfirmForm = ({
  showReason,
  showIsInFutureWarning,
  showSeen,
  seen,
  setSeen,
  userInitial,
  setUserInitial,
  setReason,
  reason
}) => {
  return (
    <>
      {showIsInFutureWarning && (
        <div className="warning-message-container">
          <WarningIcon className="warning-icon" />
          <p>
            {"Caution: You're about to mark a task as complete that is scheduled for the future."}
          </p>
        </div>
      )}
      <p>Please enter your initial</p>
      <input
        type="text"
        className="input"
        name="userInitialInput"
        value={userInitial}
        onChange={(e) => setUserInitial(e.target.value)}
        explorator_test_id={"to_do_list_action_button_model_initials_input"}
      />
      {showReason && (
        <>
          <StyledTextAreaLabel>Reason</StyledTextAreaLabel>
          <textarea
            className="textarea"
            name="reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            explorator_test_id={"to_do_list_action_button_model_reason_input"}
          ></textarea>
        </>
      )}
      {showSeen && <StyledSeenCheckbox seen={seen} setSeen={setSeen} />}
    </>
  );
};

// TODO remove unsused
TODOListModalBaseConfirmForm.propTypes = {
  handleClose: PropTypes.func,
  handleSubmit: PropTypes.func,
  modalOpen: PropTypes.bool,
  requireReason: PropTypes.bool,
  userInitial: PropTypes.string,
  setUserInitial: PropTypes.func,
  setReason: PropTypes.func,
  reason: PropTypes.string,
  type: PropTypes.string,
  seen: PropTypes.bool,
  setSeen: PropTypes.func,
  skipOccurrenceType: PropTypes.string,
  setSkipOccurrenceType: PropTypes.func,
  todoListIsInPresentOrPast: PropTypes.bool,
  showReason: PropTypes.bool,
  showIsInFutureWarning: PropTypes.bool,
  showSeen: PropTypes.bool
};

const StyledSeenCheckbox = styled(SeenCheckbox)`
  margin-top: 1rem;
  margin-bottom: 0.5rem;
`;

const StyledTextAreaLabel = styled.p`
  margin-top: 0.5rem;
`;
